import { render, staticRenderFns } from "./SportelloOspitiIdView.vue?vue&type=template&id=6d2a5191&"
import script from "./SportelloOspitiIdView.vue?vue&type=script&lang=ts&"
export * from "./SportelloOspitiIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports